<script>
import {ref} from "vue";
import Swal from "sweetalert2";
import LoadingPage from "@/components/assetComponents/LoadingPage.vue";
import LoadingPic from "@/components/assetComponents/LoadingPic.vue";
import $ from "jquery";
import router from "@/router";
import {useRoute} from "vue-router";
import FreeWorld from "@/assets/js/FreeWorld";
import Swals from "@/assets/js/Swals";
import NavbarPage from "@/components/assetComponents/NavbarPage.vue";
import FooterPage from "@/components/assetComponents/FooterPage.vue";

export default {
  name: "AddNewAdvertising",
  components: {FooterPage, NavbarPage, LoadingPic, LoadingPage},

  setup() {
    document.body.scrollTop = 0
    document.documentElement.scrollTop = 0

    let page = ref('one')
    let loading = ref(false)

    let place = ref({
      state_name: null,
      city_name: null,
      // street_name: null,
    })
    let page_select_place = ref('state')

    let country = ref([])
    let citys = ref([])
    // let streets = ref([])

    let sub_cats = ref([])

    let data = ref({
      adver_name: null,
      pic: [],
      description: null,
      phone: null,
      category_id: null,
      state_id: null,
      city_id: null,
      // street_id: null,
      type_partnership_id: null,
      experience_id: null,
      payment_id: null,
      bime_id: null,
      military_id: null,
      request_person: 1,
      chat_active: false,
    })

    let filters = ref([])

    let pic_one = ref(null)
    let loading_one_pic = ref(false)
    let loading_two_pic = ref(false)
    let pic_two = ref(null)

    let input_chats = ref(false)

    let select_cat = ref(null)
    let action = ref(useRoute().params.action)


    function load_country() {

      loading.value = true

      FreeWorld.Heisenberg({}, 'user/city').then((result) => {

        let res = result.data
        country.value = res.results

        // ************** "دریافت فیلتر ها" *************

        FreeWorld.Heisenberg({}, 'adver_filter').then((result) => {

          loading.value = false
          let res = result.data
          filters.value = res.filter
          sub_cats.value = res.category

          filters.value.forEach((item) => {
            item.myselect = null
          })

          if (action.value != 'new') {
            change_edit()
          }

        }).catch((result) => {
          loading.value = false
          Swals.Catch(result, load_country)
        })


      }).catch((result) => {
        loading.value = false
        Swals.Catch(result, load_country)
      })
    }

    load_country()

    function change_edit() {

      loading.value = true
      FreeWorld.Heisenberg({profile_id: action.value, action: 'show'}, 'adver_edit', true).then((result) => {

        loading.value = false
        let res = result.data

        data.value = {
          adver_name: res.adver_name,
          pic: res.pic,
          description: res.description,
          phone: res.phone,
          category_id: res.category_id,
          sub_category: res.sub_category,
          state_id: res.state_id,
          city_id: res.city_id,
          // street_id: res.street_id,
          type_partnership_id: res.type_partnership_id,
          experience_id: res.experience_id,
          payment_id: res.payment_id,
          bime_id: res.bime_id,
          military_id: res.military_id,
          request_person: res.request_person,
          chat_active: false,
        }

        if (res.chat_active == 1) {
          input_chats.value = true
          data.value.chat_active = true
        }
        if (res.pic[0]) {
          pic_one.value = res.pic[0]
        }
        if (res.pic[1]) {
          pic_two.value = res.pic[1]
        }

        sub_cats.value.forEach((item) => {
          if (data.value.sub_category == item.sub_cat_id) {
            select_cat.value = item
          }
        })

        country.value.forEach((item) => {
          if (data.value.state_id == item.id) {
            place.value.state_name = item.name
            item.city.forEach((city) => {
              if (data.value.city_id == city.id) {
                place.value.city_name = city.name
                // city.street.forEach((street) => {
                //   if (data.value.street_id == street.id) {
                //     place.value.street_name = street.name
                //   }
                // })
              }
            })
          }
        })

        filters.value.forEach((item) => {

          if (item.name == 'نوع همکاری') {

            item.myselect = data.value.type_partnership_id

          }

          if (item.name == 'وضعیت سربازی') {

            item.myselect = data.value.military_id

          }

          if (item.name == 'بیمه') {

            item.myselect = data.value.bime_id

          }

          if (item.name == 'شیوه پرداخت') {

            item.myselect = data.value.payment_id

          }

          if (item.name == 'نیاز به سابقه') {

            item.myselect = data.value.experience_id

          }

        })


      }).catch((result) => {
        loading.value = false
        Swals.Catch(result, change_edit)
      })

    }

    function change_country(status, id, name) {

      if (status == 'state') {

        country.value.forEach((item) => {
          if (id == item.id) {
            citys.value = item.city
            place.value.state_name = item.name
            return false
          }
        })
        data.value.state_id = id
        page_select_place.value = 'city'

      } else if (status == 'city') {
        // citys.value.forEach((item) => {
        //   if (id == item.id) {
        //     streets.value = item.street
        //   }
        // })
        // page_select_place.value = 'street'

        data.value.city_id = id
        place.value.city_name = name
        open_select_place()
      }

      // else if (status == 'street') {
      //   place.value.street_name = name
      //   data.value.street_id = id
      // }

    }

    function open_select_place() {

      let alert = document.getElementById('select_state')
      let background = document.getElementById('alert_background_place')
      page_select_place.value = 'state'


      if (country.value[0]) {

        if (alert.style.display != 'block') {

          place.value.state_name = null
          place.value.city_name = null
          data.value.state_id = null
          data.value.city_id = null

          $("#select_state").removeClass('animate__fadeOut')
          $("#select_state").addClass('animate__fadeIn')
          alert.style.display = 'block'
          background.style.display = 'block'

        } else {

          if (place.value.city_name === null) {
            // place.value.street_name = null
            // data.value.street_id = null
            place.value.city_name = null
            place.value.state_name = null
            data.value.state_id = null
            data.value.city_id = null
          }

          $("#select_state").addClass('animate__fadeOut')
          setTimeout(() => {
            alert.style.display = 'none'
            background.style.display = 'none'
          }, 600)

        }

      } else {

        Swal.fire({
          icon: 'error',
          confirmButtonText: 'تلاش مجدد',
          text: 'لطفا فیلتر شکن را خاموش کرده یا وضعیت اینترنت را برسی کنید',
          allowOutsideClick: false,
        }).then((result) => {
          if (result.isConfirmed) {
            load_country()
          }
        })
      }
    }

    function upload_one_pic(e) {

      const file = e.target.files[0];
      if (file) {
        loading_one_pic.value = true

        FreeWorld.Goodman(file).then((res) => {

          loading_one_pic.value = false
          if (res) {
            pic_one.value = URL.createObjectURL(file);
            data.value.pic[0] = res.data.url
          }

        }).catch((result) => {
          loading_one_pic.value = false
          Swals.Catch(result, () => {
            upload_one_pic(e)
          })
        })
      }
    }

    function upload_two_pic(e) {

      const file = e.target.files[0];
      if (file) {

        loading_two_pic.value = true
        FreeWorld.Goodman(file).then((res) => {

          loading_two_pic.value = false
          if (res) {
            pic_two.value = URL.createObjectURL(file);
            data.value.pic[1] = res.data.url
          }

        }).catch((result) => {
          loading_two_pic.value = false
          Swals.Catch(result, () => {
            upload_two_pic(e)
          })
        })
      }


    }

    function remove_pic(action) {

      if (action == 'one') {

        pic_one.value = null
        data.value.pic.splice([0])
        if (pic_two.value != null) {
          pic_two.value = null
        }

      }
      if (action == 'two') {

        pic_two.value = null
        data.value.pic.splice([1])

      }


    }

    function active_chats() {

      input_chats.value = !input_chats.value

      if (input_chats.value == true) {
        data.value.chat_active = 1
      } else {
        data.value.chat_active = 0
      }

    }

    function created_advertising() {

      filters.value.forEach((item) => {

        if (item.name == 'نوع همکاری') {

          data.value.type_partnership_id = item.myselect

        }

        if (item.name == 'وضعیت سربازی') {

          data.value.military_id = item.myselect

        }

        if (item.name == 'بیمه') {

          data.value.bime_id = item.myselect

        }

        if (item.name == 'شیوه پرداخت') {

          data.value.payment_id = item.myselect

        }

        if (item.name == 'نیاز به سابقه') {

          data.value.experience_id = item.myselect

        }

      })

      if (data.value.adver_name == null || data.value.adver_name.trim().length == 0) {

        Swal.fire({
          text: "لطفا عنوان آگهی خود را وارد کنید!",
          icon: "warning",
          showCancelButton: false,
          confirmButtonText: "متوجه شدم",
          showClass: {
            popup: 'animate__animated animate__bounceInDown'
          },
          hideClass: {
            popup: 'animate__animated animate__bounceOutUp'
          }
        }).then((result) => {
          if (result.isConfirmed) {
            page.value = 'one'
          }
        });

      } else if (data.value.description == null || data.value.description.trim().length == 0) {

        Swal.fire({
          text: "لطفا توضیحات آگهی خود را وارد کنید!",
          icon: "warning",
          showCancelButton: false,
          confirmButtonText: "متوجه شدم",
          showClass: {
            popup: 'animate__animated animate__bounceInDown'
          },
          hideClass: {
            popup: 'animate__animated animate__bounceOutUp'
          }
        }).then((result) => {
          if (result.isConfirmed) {
            page.value = 'one'
          }
        });

      } else if (data.value.phone == null || data.value.phone.length == 0) {

        Swal.fire({
          text: "لطفا شماره تماس خود را وارد کنید!",
          icon: "warning",
          showCancelButton: false,
          confirmButtonText: "متوجه شدم",
          showClass: {
            popup: 'animate__animated animate__bounceInDown'
          },
          hideClass: {
            popup: 'animate__animated animate__bounceOutUp'
          }
        }).then((result) => {
          if (result.isConfirmed) {
            page.value = 'one'
          }
        });

      } else if (data.value.phone.length != 11 || data.value.phone.charAt(0) != 0 || data.value.phone.charAt(1) != 9) {

        Swal.fire({
          text: "لطفا شماره تماس  خود را به صورت صحیح وارد کنید!",
          icon: "warning",
          showCancelButton: false,
          confirmButtonText: "متوجه شدم",
          showClass: {
            popup: 'animate__animated animate__bounceInDown'
          },
          hideClass: {
            popup: 'animate__animated animate__bounceOutUp'
          }
        }).then((result) => {
          if (result.isConfirmed) {
            page.value = 'one'
          }
        });

      } else if (select_cat.value == null) {

        Swal.fire({
          text: "لطفا دسته بندی آگهی خود را انتخاب کنید!",
          icon: "warning",
          showCancelButton: false,
          confirmButtonText: "متوجه شدم",
          showClass: {
            popup: 'animate__animated animate__bounceInDown'
          },
          hideClass: {
            popup: 'animate__animated animate__bounceOutUp'
          }
        }).then((result) => {
          if (result.isConfirmed) {
            page.value = 'two'
          }
        });

      } else if (place.value.city_name == null) {

        Swal.fire({
          text: "لطفا محدوده آگهی خود را انتخاب کنید!",
          icon: "warning",
          showCancelButton: false,
          confirmButtonText: "متوجه شدم",
          showClass: {
            popup: 'animate__animated animate__bounceInDown'
          },
          hideClass: {
            popup: 'animate__animated animate__bounceOutUp'
          }
        }).then((result) => {
          if (result.isConfirmed) {
            page.value = 'two'
          }
        });

      } else {


        data.value.category_id = select_cat.value.id

        let url = 'adver_add'

        if (action.value !== 'new') {
          url = 'adver_edit'
          data.value.action = 'edite'
          data.value.profile_id = action.value
        }

        loading.value = true
        FreeWorld.Heisenberg(data.value, url, true).then((result) => {

          loading.value = false
          var res = result.data

          let message = {
            ok: "آگهی شما بعد از پرداخت ثبت میشود",
            error: "متاسفانه آگهی شما ثبت نشد"
          }

          if (data.value.action) {
            message.ok = "آگهی شما با موفقیت ویرایش شد"
            message.error = "متاسفانه آگهی شما ویرایش نشد"
          }
          if (res.status == 'ok') {

            Swal.fire({
              position: "center",
              icon: "success",
              title: message.ok,
              showConfirmButton: true,
              confirmButtonText: 'پرداخت',
              allowOutsideClick: false,
              showClass: {
                popup: 'animate__animated animate__bounceInDown'
              },
              hideClass: {
                popup: 'animate__animated animate__bounceOutUp'
              }
            }).then((result) => {

              if (result.isConfirmed) {

                action.value === 'new' ? window.location.href = res.url : router.push({name: 'MyAdvers'})

              }

            })

          } else {

            Swal.fire({
              position: "center",
              icon: "error",
              title: message.error,
              showConfirmButton: true,
              confirmButtonText: 'متوجه شدم',
              allowOutsideClick: false,
              showClass: {
                popup: 'animate__animated animate__bounceInDown'
              },
              hideClass: {
                popup: 'animate__animated animate__bounceOutUp'
              }
            }).then((result) => {

              if (result.isConfirmed)
                router.push({name: 'HomePage'})
            })

          }

        }).catch((result) => {
          loading.value = false
          Swals.Catch(result, created_advertising)
        })
      }
    }

    return {

      page,
      place,
      loading,
      change_country,
      open_select_place,
      country,
      // streets,
      citys,
      data,
      page_select_place,
      pic_one,
      pic_two,
      active_chats,
      input_chats,
      upload_one_pic,
      upload_two_pic,
      loading_one_pic,
      loading_two_pic,
      remove_pic,
      filters,
      created_advertising,
      sub_cats,
      select_cat,
      action,

    }
  }
}
</script>

<template>

  <LoadingPage v-if="loading"></LoadingPage>
  <div @click="open_select_place" v-show="dialog" id="alert_background_place" class="alert_background"></div>
  <div dir="ltr" v-show="dialog" id="select_state" class="select_state px-5 mt-3 max_width animate__animated animate__fadeIn">
    <div class="bg-white rounded-4 border-costom">
      <div class="bg-color-liner position-relative rounded-top-4 d-flex justify-content-center align-items-center">
        <img @click="open_select_place" class="icon_closing_filter position-absolute" style="width: 15px"
             src="../assets/img/closing.svg" alt="">
        <img class="py-4" style="width: 100px" src="../assets/img/location_white.svg" alt="">
      </div>

      <div v-if="page_select_place == 'state' " class="px-2 py-3 overflow-y-scroll" style="height: 400px">

        <div v-for="item in country" :key="item.id" @click="change_country('state', item.id)"
             class="d-flex justify-content-between py-3">
          <img class="m-0 mx-2" style="width: 8px" src="../assets/img/down-arrow.svg" alt="">

          <p class="m-0">{{ item.name }}</p>
        </div>

      </div>

      <div v-if="page_select_place == 'city' " class="px-2 py-3 overflow-y-scroll" style="height: 400px">

        <div v-for="item in citys" :key="item.id" @click="change_country('city', item.id , item.name)"
             class="d-flex justify-content-between py-3">
          <img class="m-0 mx-2" style="width: 8px" src="../assets/img/down-arrow.svg" alt="">

          <p class="m-0">{{ item.name }}</p>
        </div>

      </div>

      <!--        <div v-if="page_select_place == 'street' " class="px-2 py-3 overflow-y-scroll" style="height: 400px">-->

      <!--          &lt;!&ndash;          <div @click="change_country('all_street')" class="d-flex justify-content-between py-3">&ndash;&gt;-->
      <!--          &lt;!&ndash;            <img class="m-0 mx-2" style="width: 8px" src="../assets/img/down-arrow.svg" alt="">&ndash;&gt;-->
      <!--          &lt;!&ndash;            <p class="m-0 font-5">همه خیابان ها</p>&ndash;&gt;-->
      <!--          &lt;!&ndash;          </div>&ndash;&gt;-->

      <!--          <div v-for="item in streets" :key="item.id" @click="change_country('street', item.id , item.name)"-->
      <!--               class="d-flex justify-content-between py-3">-->
      <!--            <img class="m-0 mx-2" style="width: 8px" src="../assets/img/down-arrow.svg" alt="">-->
      <!--            <p class="m-0 font-5">{{ item.name }}</p>-->
      <!--          </div>-->

      <!--        </div>-->

    </div>
  </div>


  <div dir="ltr" id="main" :class="loading ? 'activeClass' : '' " class="bg-main">
    <div v-if="page === 'one' ">
      <div class="div-top-arrow bg-color d-flex align-items-center justify-content-between">
        <router-link to="/HomePage" class="d-flex align-items-center text-decoration-none text-white">
          <p class="m-0">
            انصراف
          </p>
          <img class="svg-arrow" src="../assets/img/closing.svg" alt="">
        </router-link>
        <div class="d-flex align-items-center">
          <p class="m-0">
            ثبت آگهی
          </p>
          <router-link to="/HomePage" class="text-decoration-none">
            <img class="svg-arrow" src="../assets/img/back.svg" alt="">
          </router-link>
        </div>
      </div>
      <br>
      <br>
      <br>
      <div class="p-body mt-2 animate__animated animate__fadeIn">

        <div class="w-100">

          <p class="font-4 font-bold text-end">
            عکس آگهی
          </p>
          <p class="font-5 text-end">
            افزودن عکس بازدید اگهی شما را افزایش می دهد
          </p>

          <div class="list_photos">

            <div class="add_prolile rounded-4 mx-1 position-relative"
                 :style="pic_one == null ? 'border: 1px solid #FF6F00' : '' ">
              <img @click="remove_pic('one')" v-if="pic_one != null " style="width: 25px; right: 3px; top: 3px"
                   class="position-absolute z-1" src="../assets/img/closing_color.svg" alt="">
              <label :class="loading_one_pic ? 'pe-none' : '' " for="one"
                     style="position: relative; width:100%;height:100%;overflow:hidden;padding:0;cursor:pointer">

                <LoadingPic v-if="loading_one_pic"></LoadingPic>

                <img v-if="pic_one == null" id="slider_client_add_2" src="../assets/img/add_picture.svg"
                     style="width:100%;height:100%;border-radius: 10px;">

                <img v-else id="slider_client_add_2" :src="pic_one"
                     style="width:100%;height:100%;border-radius: 10px;">

              </label>
              <input @change="upload_one_pic" type="file" name="file" id="one" style="display: none">
            </div>


            <div class="add_prolile rounded-4 mx-1 position-relative" :class="pic_one == null ? 'pe-none':'' ">
              <img @click="remove_pic('two')" v-if="pic_two != null " style="width: 25px; right: 3px; top: 3px"
                   class="position-absolute z-1" src="../assets/img/closing_color.svg" alt="">
              <label :class="loading_two_pic ? 'pe-none' : '' " for="two"
                     style="position: relative; width:100%;height:100%;overflow:hidden;padding:0;cursor:pointer">

                <LoadingPic v-if="loading_two_pic"></LoadingPic>

                <img v-if="pic_two == null" id="slider_client_add_2" src="../assets/img/add_picture.svg"
                     style="width:100%;height:100%;border-radius: 10px;">

                <img v-else id="slider_client_add_2" :src="pic_two"
                     style="width:100%;height:100%;border-radius: 10px;">

              </label>
              <input @change="upload_two_pic" type="file" name="file" id="two" style="display: none">
            </div>


          </div>

        </div>

        <hr>

        <div class="w-100">

          <p class="font-4 font-bold text-end">
            عنوان آگهی
          </p>
          <p class="font-5 text-end">
            در عنوان آگهی به موارد مهم اشاره کنید
          </p>

          <input v-model="data.adver_name" maxlength="50" class="p-2 w-100 input_dir bg-white border-costom rounded-3"
                 type="text">

        </div>

        <hr>

        <div class="w-100">

          <p class="font-4 font-bold text-end">
            توضیحات آگهی
          </p>
          <p class="font-5 text-end">
            جزئیات و نکات قابل توجه آگهی خود را کامل و دقیق بنویسید
          </p>

          <textarea v-model="data.description" maxlength="300"
                    class="textarea_users input_dir w-100 border-costom p-2 bg-white rounded-4"></textarea>

        </div>

        <hr>

        <div class="w-100">

          <p class="font-4 font-bold text-end">
            شماره تلفن
          </p>
          <p class="font-5 text-end">
            شماره تلفن درج در آگهی
          </p>

          <input v-model="data.phone" maxlength="11" onkeydown="return event.key != ' '"
                 class="p-2 w-100 text-center border-costom bg-white rounded-3" type="tel">

        </div>

      </div>


      <div class="button_div w-100 mt-2 p-body d-flex justify-content-start mt-5">
        <v-btn @click="page = 'two' "
               class="w-45 h-100 bg-color rounded-2 border-costom font-color-whit font-4 text-white">
          بعدی
        </v-btn>
      </div>
    </div>

    <div v-if="page === 'two' ">

      <div class="div-top-arrow bg-color d-flex align-items-center justify-content-between">
        <div onclick="window.location.href = '/HomePage' " class="d-flex align-items-center">
          <p class="m-0">
            انصراف
          </p>
          <img class="svg-arrow" src="../assets/img/closing.svg" alt="">
        </div>
        <div class="d-flex align-items-center">
          <p class="m-0">
            ثبت آکهی
          </p>
          <div @click="page = 'one' " class="">
            <img class="svg-arrow" src="../assets/img/back.svg" alt="">
          </div>
        </div>
      </div>
      <br>
      <br>
      <br>


      <div class="p-body animate__animated animate__fadeIn">
        <div class="p-3 bg-white rounded-3 mt-2">

          <div class=" d-flex justify-content-between align-items-center py-2">
            <div class="d-flex align-items-center">
              <img style="width: 8px;" src="../assets/img/down-arrow.svg" alt="">

              <select v-model="select_cat" class="ml-2 font-5 w-100">
                <option :value="null">انتخاب</option>
                <option v-for="item in sub_cats" :key="item.cat_id" :value="item">{{ item.name }}</option>
              </select>

            </div>
            <p class="m-0 font-4 d-flex align-items-center">
              <span class="font-color-red mr-2 font-5">اجباری</span>
              <span class="">دسته بندی آگهی</span>
            </p>
          </div>

          <hr>

          <div class=" d-flex justify-content-between align-items-center py-2">
            <div class="d-flex align-items-center">
              <img style="width: 8px" src="../assets/img/down-arrow.svg" alt="">

              <select v-model="data.request_person" class="ml-2 font-5 w-100">
                <option :value="1">کارفرما</option>
                <option :value="2">کارجو</option>
              </select>

            </div>
            <p class="m-0 font-4">
              آگهی دهنده
            </p>
          </div>

          <hr>

          <div class=" d-flex justify-content-between align-items-center py-2">

            <div class="d-flex align-items-center">
              <img style="width: 8px" src="../assets/img/down-arrow.svg" alt="">

              <div @click="open_select_place" v-if="place.city_name != null " class="d-flex ml-2">

                <p class="m-0 font-5 d-flex align-items-center">{{ place.city_name }}</p>

              </div>

              <p v-else @click="open_select_place" class="m-0 font-5 mx-2">
                انتخاب
              </p>

            </div>

            <p class="m-0 font-4 d-flex align-items-center">
              <span class="font-color-red mr-2 font-5">اجباری</span>
              <span class="">محدوده آگهی</span>
            </p>

          </div>


          <div v-for="item in filters" :key="item.id">

            <hr>

            <div class=" d-flex justify-content-between align-items-center py-2">
              <div class="d-flex align-items-center">
                <img style="width: 8px" src="../assets/img/down-arrow.svg" alt="">

                <select v-model="item.myselect" class="ml-2 font-5 w-100">
                  <option :value="null">انتخاب</option>
                  <option v-for="items in item.sub" :key="items.id" :value="items.id"> {{ items.name }}</option>
                </select>

              </div>

              <p class="m-0 font-4">{{ item.name }}</p>

            </div>

          </div>

        </div>

        <br>

        <div class="bg-white d-flex justify-content-between rounded-3 p-body align-items-center py-3">
          <div class="d-flex align-items-center">
            <input @click="active_chats" v-model="input_chats" id="active_chats" type="checkbox">
          </div>
          <p class="m-0">
            چت آگهی فعال باشد؟
          </p>
        </div>
        <br>

      </div>

      <br>
      <br>

      <div v-if="action == 'new' "
           class="button_div w-100 d-flex position-fixed bottom-0 max_width justify-content-center bg-main">
        <v-btn @click="created_advertising" class="w-50 h-75 bg-color rounded-3 border-costom text-white my-2 ">
          ثبت آگهی
        </v-btn>
      </div>

      <div v-else class="button_div w-100 d-flex position-fixed bottom-0 max_width justify-content-center bg-main">
        <v-btn @click="created_advertising" class="w-50 h-75 bg-color rounded-3 border-costom text-white my-2 ">
          ویرایش آگهی
        </v-btn>
      </div>


    </div>
  </div>

  <div id="web" :class="loading ? 'activeClass' : '' " class="bg-main">

    <NavbarPage></NavbarPage>
    <div style="background-color: white" class="rounded-4 font-bold font-color p-3 mb-4 w-75 ma-auto">افزودن آگهی جدید
    </div>

    <div v-if="page === 'one'" class="p-4 w-75 rounded-4 bg-white m-auto">

      <div class="animate__animated animate__fadeIn">

        <div class="w-100">
          <p class="font-5 mb-2 font-bold text-end">عکس آگهی</p>
          <p class="font-4 mb-3 text-end">افزودن عکس بازدید اگهی شما را افزایش می دهد</p>

          <div class="list_photos">
            <div class="add_prolile shadow-costom rounded-4 mx-1 position-relative"
                 :style="pic_one == null ? 'border: 1px solid #FF6F00' : '' ">
              <img @click="remove_pic('one')" v-if="pic_one != null " style="width: 25px; right: 3px; top: 3px"
                   class="position-absolute z-1" src="../assets/img/closing_color.svg" alt="">
              <label :class="loading_one_pic ? 'pe-none' : '' " for="one"
                     style="position: relative; width:100%;height:100%;overflow:hidden;padding:0;cursor:pointer">

                <LoadingPic v-if="loading_one_pic"></LoadingPic>

                <img v-if="pic_one == null" id="slider_client_add_2" src="../assets/img/add_picture.svg"
                     style="width:100%;height:100%;border-radius: 10px;">

                <img v-else id="slider_client_add_2" :src="pic_one"
                     style="width:100%;height:100%;border-radius: 10px;">

              </label>
              <input @change="upload_one_pic" type="file" name="file" id="one" style="display: none">
            </div>

            <div class="add_prolile shadow-costom rounded-4 mx-1 position-relative"
                 :class="pic_one == null ? 'pe-none':'' ">
              <img @click="remove_pic('two')" v-if="pic_two != null " style="width: 25px; right: 3px; top: 3px"
                   class="position-absolute z-1" src="../assets/img/closing_color.svg" alt="">
              <label :class="loading_two_pic ? 'pe-none' : '' " for="two"
                     style="position: relative; width:100%;height:100%;overflow:hidden;padding:0;cursor:pointer">

                <LoadingPic v-if="loading_two_pic"></LoadingPic>

                <img v-if="pic_two == null" id="slider_client_add_2" src="../assets/img/add_picture.svg"
                     style="width:100%;height:100%;border-radius: 10px;">

                <img v-else id="slider_client_add_2" :src="pic_two"
                     style="width:100%;height:100%;border-radius: 10px;">

              </label>
              <input @change="upload_two_pic" type="file" name="file" id="two" style="display: none">
            </div>
          </div>
        </div>

        <hr>

        <div class="w-100">
          <p class="font-5 mb-2 font-bold text-end">عنوان آگهی</p>
          <p class="font-4 mb-3 text-end">در عنوان آگهی به موارد مهم اشاره کنید</p>

          <input v-model="data.adver_name" maxlength="50" class="p-2 w-100 input_dir bg-white border-costom rounded-3"
                 type="text">
        </div>

        <hr>

        <div class="w-100">
          <p class="font-5 mb-2 font-bold text-end">توضیحات آگهی</p>
          <p class="font-4 mb-3 text-end">جزئیات و نکات قابل توجه آگهی خود را کامل و دقیق بنویسید</p>

          <textarea v-model="data.description" maxlength="300"
                    class="textarea_users input_dir w-100 border-costom p-2 bg-white rounded-4"></textarea>
        </div>

        <hr>

        <div class="w-100">
          <p class="font-5 mb-2 font-bold text-end">شماره تلفن</p>
          <p class="font-4 mb-3 text-end">شماره تلفن درج در آگهی</p>

          <input v-model="data.phone" maxlength="11" onkeydown="return event.key !== ' '"
                 class="p-2 w-100 text-center border-costom bg-white rounded-3" type="tel">
        </div>

      </div>


      <div class="w-100 mt-5 d-flex justify-content-center">
        <v-btn @click="page = 'two' "
               class="w-45 h-100 bg-color rounded-2 border-costom font-color-white text-white py-3">بعدی
        </v-btn>
      </div>
    </div>

    <div v-if="page === 'two'" class="p-4 w-50 rounded-4 bg-white m-auto">

      <div class="animate__animated animate__fadeIn">
        <div class="p-3 bg-white rounded-3 mt-2">

          <div class=" d-flex justify-content-between align-items-center py-2">
            <p class="m-0 d-flex align-items-center">
              <span class="font-bold font-5">دسته بندی آگهی</span>
              <span class="font-color-red mr-2 font-4">اجباری</span>
            </p>

            <div class="d-flex align-items-center w-40">
              <select v-model="select_cat" class="ml-2 font-5 text-center w-90">
                <option class="font-5" :value="null">انتخاب</option>
                <option class="font-5" v-for="item in sub_cats" :key="item.cat_id" :value="item">{{ item.name }}</option>
              </select>

              <img style="width: 8px;" src="../assets/img/down-arrow.svg" alt="">
            </div>
          </div>

          <hr>

          <div class=" d-flex justify-content-between align-items-center py-2">
            <p class="m-0 font-5 font-bold">
              آگهی دهنده
            </p>

            <div class="d-flex align-items-center w-40">
              <select v-model="data.request_person" class="ml-2 font-5 text-center w-90">
                <option class="font-5" :value="1">کارفرما</option>
                <option class="font-5" :value="2">کارجو</option>
              </select>

              <img style="width: 8px" src="../assets/img/down-arrow.svg" alt="">
            </div>
          </div>

          <hr>

          <div class=" d-flex justify-content-between align-items-center py-2">
            <p class="m-0 d-flex align-items-center">
              <span class="font-bold font-5">محدوده آگهی</span>
              <span class="font-color-red mr-2 font-4">اجباری</span>
            </p>

            <div class="d-flex align-items-center w-40">
              <div @click="open_select_place" v-if="place.city_name != null " class="d-flex justify-center w-90 ml-2">

                <p class="m-0 font-5 text-center d-flex align-items-center">{{ place.state_name }} - {{ place.city_name }}</p>

              </div>

              <p v-else @click="open_select_place" class="m-0 w-90 text-center font-5 mx-2">
                انتخاب
              </p>

              <img style="width: 8px" src="../assets/img/down-arrow.svg" alt="">
            </div>
          </div>


          <div v-for="item in filters" :key="item.id">

            <hr>

            <div class=" d-flex justify-content-between align-items-center py-2">
              <p class="m-0 font-5 font-bold">{{ item.name }}</p>

              <div class="d-flex align-items-center w-40">
                <select v-model="item.myselect" class="ml-2 font-5 text-center w-90">
                  <option :value="null">انتخاب</option>
                  <option v-for="items in item.sub" :key="items.id" :value="items.id"> {{ items.name }}</option>
                </select>

                <img style="width: 8px" src="../assets/img/down-arrow.svg" alt="">
              </div>
            </div>

          </div>

        </div>

        <br>

        <div class="bg-white d-flex rounded-3 p-body align-items-center py-3">

          <div class="d-flex align-items-center">
            <input @click="active_chats" v-model="input_chats" id="active_chats" type="checkbox">
          </div>

          <p class="m-0 mx-2">
            چت آگهی فعال باشد؟
          </p>
        </div>
        <br>

      </div>

      <br>
      <br>

      <div v-if="action === 'new' " class="w-100 d-flex justify-content-center">
        <v-btn @click="created_advertising" class="w-40 h-100 bg-color rounded-3 border-costom text-white py-3">
          ثبت آگهی
        </v-btn>
      </div>

      <div v-else class="w-100 d-flex justify-content-center">
        <v-btn @click="created_advertising" class="w-40 h-100 bg-color rounded-3 border-costom text-white py-3">
          ویرایش آگهی
        </v-btn>
      </div>


    </div>

    <FooterPage></FooterPage>
  </div>

</template>

<style scoped>

.list_photos {
  display: -webkit-box;
  direction: rtl;
}


.add_prolile {
  width: 140px;
  height: 145px;
}

.textarea_users {
  height: 150px;
  resize: none;
  text-align: right;
}

.button_div {
  height: 3.5rem;
}


#select_state {
  position: fixed;
  width: 100%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 20;
}

.icon_closing_filter {
  top: 15px;
  left: 15px;
}


.alert_background {
  position: fixed;
  top: 0;
  height: 100vh;
  width: 100vw;
  background-color: rgba(79, 78, 78, 0.7);
  z-index: 19;
}


</style>